"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HookComponent = exports.useStripeContext = exports.Stripe = void 0;
var Stripe_1 = require("./Stripe/Stripe");
Object.defineProperty(exports, "Stripe", { enumerable: true, get: function () { return Stripe_1.Stripe; } });
Object.defineProperty(exports, "useStripeContext", { enumerable: true, get: function () { return Stripe_1.useStripeContext; } });
__exportStar(require("./Stripe/types"), exports);
var HookComponent_1 = require("./HookComponent/HookComponent");
Object.defineProperty(exports, "HookComponent", { enumerable: true, get: function () { return HookComponent_1.HookComponent; } });
